import { supabase } from './supabase';

export async function enablePushNotifications(publicKey: string, userId: string) {
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notifications are blocked. Allow them in your browser or device settings.');
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription() || await registration.pushManager.subscribe({
    userVisibleOnly: true, applicationServerKey: publicKey,
  });
  const data = subscription.toJSON();
  if (!data.endpoint || !data.keys) throw new Error('This device could not register for notifications.');
  const { error } = await supabase.from('push_subscriptions').upsert({
    user_id: userId, endpoint: data.endpoint, p256dh: data.keys.p256dh, auth: data.keys.auth,
  }, { onConflict: 'endpoint' });
  if (error) throw new Error('Could not enable notifications. Please try again.');
}

export async function disablePushNotifications() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
  const registration = await navigator.serviceWorker.getRegistration();
  const subscription = await registration?.pushManager.getSubscription();
  if (!subscription) return;
  // Unsubscribe locally even if the device cannot reach the database at sign-out.
  try { await supabase.from('push_subscriptions').delete().eq('endpoint', subscription.endpoint); }
  finally { await subscription.unsubscribe(); }
}
